import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import TEnvReader from 'tbase/readers/Env';
import apiService, { getDefaultHeader } from './apiService';
var BASE_URL = "".concat(TEnvReader.cmdsUrl(process.env), "api/");
export var fetchUserPreference = function fetchUserPreference(assetType) {
  var apiUrl = "settings/preference/u/v1.0.0/listView/".concat(assetType, "/preference");
  return apiService(BASE_URL, getDefaultHeader()).get(apiUrl);
};
export var updateUserPreference = function updateUserPreference(assetType, payload) {
  var apiUrl = "settings/preference/u/v1.0.0/listView/".concat(assetType, "/preference");
  return apiService(BASE_URL, getDefaultHeader()).post(apiUrl, payload);
};
export var fetchColumnPreference = function fetchColumnPreference(assetType) {
  var apiUrl = "settings/u/v1.0.0/user/column-preferences/assetType/".concat(assetType);
  return apiService(BASE_URL, getDefaultHeader()).get(apiUrl);
};
export var updateColumnPreference = function updateColumnPreference(assetType, payload) {
  var apiUrl = "settings/u/v1.0.0/user/column-preferences/assetType/".concat(assetType);
  return apiService(BASE_URL, getDefaultHeader()).post(apiUrl, payload);
};
export var fetchUserPartsPreference = function fetchUserPartsPreference(assetType) {
  var apiUrl = "parts/proxy/u/preference/".concat(assetType);
  return apiService(BASE_URL, getDefaultHeader()).get(apiUrl);
};
export var updateUserPartsPreference = function updateUserPartsPreference(assetType, payload) {
  var apiUrl = 'parts/proxy/u/preference';

  var reqPayload = _objectSpread({
    assetType: assetType
  }, payload);

  return apiService(BASE_URL, getDefaultHeader()).post(apiUrl, reqPayload);
};